import { render, staticRenderFns } from "./healthWarning.vue?vue&type=template&id=7d2714f6&scoped=true&"
import script from "./healthWarning.vue?vue&type=script&lang=js&"
export * from "./healthWarning.vue?vue&type=script&lang=js&"
import style0 from "./healthWarning.vue?vue&type=style&index=0&id=7d2714f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2714f6",
  null
  
)

export default component.exports